import { Dispatch, SetStateAction, memo, useEffect } from 'react';

import { Button, Flex, Group, Modal, Select, TextInput } from '@mantine/core';
import { isNotEmpty, useForm } from '@mantine/form';

import { PassTypeRequestBodyType } from '@/types/pass-types';
import { PassType } from '@/types/person';

interface PassTypesFormProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	passType: PassType | null;
	onUpdate: (body: PassTypeRequestBodyType, id: number) => Promise<void>;
	onCreate: (body: PassTypeRequestBodyType) => Promise<void>;
	handleClose: () => void;
}

function PassTypesForm({
	isOpen,
	setIsOpen,
	passType,
	onUpdate,
	onCreate,
	handleClose,
}: PassTypesFormProps) {
	const form = useForm({
		initialValues: {
			name: passType?.name ?? '',
			kind: passType?.kind ?? '',
		},
		validate: {
			name: isNotEmpty('Введите название'),
			kind: isNotEmpty('Выберите тип'),
		},
	});

	const handleSubmit = async (data: PassTypeRequestBodyType) => {
		try {
			if (passType) {
				await onUpdate(data, passType.id);
				setIsOpen(false);
				return;
			}
			await onCreate(data);
		} catch (e) {
			void 0;
		}
	};

	useEffect(() => {
		form.setValues({
			name: passType?.name ?? '',
			kind: passType?.kind ?? '',
		});
	}, [passType]);

	return (
		<>
			<Modal
				title={`${passType ? 'Изменение' : 'Создание'} пропуска`}
				opened={isOpen}
				onClose={() => {
					handleClose();
					form.reset();
				}}
				centered
				size="md"
			>
				<form
					onSubmit={form.onSubmit((values) => {
						handleSubmit(values);
						form.reset();
					})}
				>
					<Flex direction="column" gap="md">
						<TextInput
							label="Название"
							placeholder="Введите название пропуска"
							withAsterisk
							{...form.getInputProps('name')}
						/>
						<Select
							label="Тип"
							w="100%"
							data={[
								{ value: 'car', label: 'Автомобиль' },
								{ value: 'personal', label: 'Персональный' },
								{ value: 'virtual', label: 'Виртуальный' },
								{ value: 'service', label: 'Сервисный' },
							]}
							placeholder="Выберите тип пропуска"
							allowDeselect={false}
							withAsterisk
							{...form.getInputProps('kind')}
						/>
						<Group gap="md">
							<Button radius="sm" type="submit">
								ОК
							</Button>
							<Button
								radius="sm"
								color="red"
								onClick={() => {
									handleClose();
									form.reset();
								}}
							>
								Отмена
							</Button>
						</Group>
					</Flex>
				</form>
			</Modal>
		</>
	);
}

export default memo(PassTypesForm);
